// Centralized API helpers — no localStorage, no cookies. State lives in React.
const RAW = process.env.REACT_APP_BACKEND_URL || "";
export const API_BASE = RAW.replace(/\/+$/, "") + "/api";

class HttpError extends Error {
  constructor(status, body) {
    super(`HTTP ${status}`);
    this.status = status;
    this.body = body;
  }
}

async function request(path, { method = "GET", body, signal } = {}) {
  let res;
  try {
    res = await fetch(`${API_BASE}${path}`, {
      method,
      headers: body ? { "Content-Type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined,
      signal,
    });
  } catch (e) {
    // Re-throw AbortError as-is so callers can identify it via e.name === "AbortError"
    throw e;
  }
  let parsed = null;
  const text = await res.text();
  if (text) {
    try {
      parsed = JSON.parse(text);
    } catch {
      parsed = text;
    }
  }
  if (!res.ok) {
    throw new HttpError(res.status, parsed);
  }
  return parsed;
}

export const api = {
  login: (email, name) => {
    const body = { email };
    if (name) body.name = name;
    return request("/users/login", { method: "POST", body });
  },
  getUser: (id, opts) => request(`/users/${id}`, opts),
  patchUser: (id, patch) => request(`/users/${id}`, { method: "PATCH", body: patch }),
  getProgressAll: (userId, opts) => request(`/users/${userId}/progress`, opts),
  getProgressOne: (userId, qid, opts) => request(`/users/${userId}/progress/${qid}`, opts),
  chat: ({ user_id, quest_id, message, is_first }) =>
    request("/quest/chat", {
      method: "POST",
      body: { user_id, quest_id, message, is_first },
    }),
  razorpayCreate: (user_id, amount = 499700, currency = "INR") =>
    request("/payment/razorpay/create", {
      method: "POST",
      body: { user_id, amount, currency },
    }),
  stripeCreate: (user_id, origin_url) =>
    request("/payment/stripe/create", {
      method: "POST",
      body: { user_id, origin_url },
    }),
  verifyPayment: (body) =>
    request("/payment/verify", { method: "POST", body }),
  getLeaderboard: (month, opts) =>
    request(`/leaderboard${month ? `?month=${month}` : ""}`, opts),
  getAwards: (month, opts) =>
    request(`/leaderboard/awards${month ? `?month=${month}` : ""}`, opts),
  getUserRank: (userId, month, opts) =>
    request(`/users/${userId}/rank${month ? `?month=${month}` : ""}`, opts),
  generateAwards: (month, secret) =>
    request("/leaderboard/awards/generate", {
      method: "POST",
      body: { month, secret },
    }),
  submitContact: (body) =>
    request("/contact", { method: "POST", body }),
};

export { HttpError };
